<app-search (submitted)="onSubmitted($event)"
></app-search>

<app-flag *ngIf="!pages.length"></app-flag>

<app-page-list [releventPages]="pages" *ngIf="pages.length"
></app-page-list>
